// type safe paths
// https://github.com/garybernhardt/static-path
//
// tip: unless you're adding the route to the router, always call these as a
// function even if they don't take parameters
// e.g.  <Link to={rootPath({})}> and not <Link to={rootPath.pattern}>

import { path } from "static-path"

export const rootPath = path("/")
export const loginPath = path("/login")
export const invitationLoginPath = path("/invite/:token")
export const credentialsLoginPath = path("/login/credentials")
export const detailsPath = path("/details")
// export const profilePath = path("/profile")
// export const profileEditPath = path("/profile/edit")
export const adminUsersPath = path("/admin/users")
export const adminAdminUsersPath = path("/admin/admin-users")
export const adminCreateAdminPath = path("/admin/admin-users/create")
export const adminUserProfilePath = path("/admin/users/:userId")
export const adminInviteLinksPath = path("/admin/invite-links")
export const dashboardPath = path("/dashboard")
export const invitationsPath = path("/invitations")
export const contactsPath = path("/contacts")
export const emailAuthPath = path("/auth/email/:email/:token/:clientAuthCode")
export const onboardingVerifyEmailPath = path("/onboarding/verify-email")
export const onboardingVerifyPhonePath = path("/onboarding/verify-phone")
export const onboardingAccountDetailsPath = path("/onboarding/account-details")
export const handlePath = path("/:handle")
